<template>
    <div v-if="bot">

        <i v-if="bot.advanced_settings_id==projectAdvanced.id" v-on:click="openDialog" class="el-icon-setting cursored"></i>
        <i v-else v-on:click="openDialog" class="el-icon-s-tools cursored"></i>
        <el-dialog v-if="advanced"
            :title="getTitle()"
            :visible.sync="dialogVisible"
            width="50%"
            
            >

        </el-dialog>
        <el-drawer
            class="advDrawer"
            title="Bot advanced settings"
            :visible.sync="drawer"
            :direction="direction"
            :show-close="false"
            size="100%"
            :before-close="handleClose">
                <div class="slider">
                <el-row v-loading="pbLoading">
                    <AdvancedUnited
                        :advanced="advanced"
                        :accounts="accounts"
                        :proxies="proxies"
                        :proxies_tags="proxies_tags"
                        :languages="languages"
                        :pools="pools"
                        :type="'bot'"
                        :bot="bot"
                        >
                    </AdvancedUnited>
                 </el-row>
                <el-row>
                    
                    <el-button  @click="resetToDefault()" type="info">Reset to default</el-button>
                    <el-button  @click="drawer=false" type="warning">Close</el-button>
            </el-row>
            </div>
            </el-drawer>
    </div>
    
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import AdvancedUnited from '../../../../components/AdvancedUnited';

export default {
    name: 'Advanced',
    components: {
        AdvancedUnited
    },
    props: {
        project: {
            type: Object,
            default: () => {}
        },
        bot: {
            type: Object,
            default: () => {}
        },
        projectAdvanced: {
            type: Object,
            default: () => {}
        }
    },
    mounted: function () {
        var that = this;
            this.$store.subscribe((mutation, state) => {
            if (mutation.type === 'bot/BOT_UPDATED' || mutation.type === 'project/DELETED_PLAYBOOK_ADVANCED') {
                //that.dialogVisible = false;
                that.drawer = false;
                //update bot data
                //alert('yoba');
                that.$store.dispatch('project/updateBotData', mutation.payload);
            }
            
 
        })
        this.language_codes =  this.getLanguageCodes(),
        this.country_codes = this.getCountryCodes(),
        this.settings =  this.$store.state.project.settings
        this.tags = JSON.parse(JSON.stringify(this.advanced.proxy_tags));
    
    },
    data () {
        return {
            retryNumOptions: [
                "auto", 0, 1, 2, 3, 4, 5
            ],
            drawer: false,
            direction: 'rtl',
            language_codes: [],//this.getLanguageCodes(),
            country_codes: [],// this.getCountryCodes(),
            settings: [],//this.$store.state.project.settings,
            dialogVisible: false,
            video_ratio: 0,
            selectedProxyTag: '',
            tagInput:'',
            tagIncludeInput:'',
            view: {
                tabs: 'bot'
            },
            firefoxes: [
                {
                    name:'Firefox v115.5.0 Lopata Build',
                    value:'firefox115.5.0-lpt-build'
                },
                {
                    name:'Firefox v147.0.4 Lopata Build',
                    value:'firefox147.0.4-lpt-build'
                },
            ],
            osTypes: 
            [
                {
                    label: 'I don\t care',
                    options: 
                        [
                            {
                                name:'Any',
                                value:'any'
                            },
                        ]
                },
                {
                    label: 'Desktop systems',
                    options: 
                        [
                             {
                                name:'Any desktop',
                                value:'desktop_any'
                            },
                            {
                                name:'Windows',
                                value:'desktop_windows'
                            },
                            {
                                name:'MacOs',
                                value:'desktop_macos'
                            },
                            {
                                name:'Ubuntu',
                                value:'desktop_ubuntu'
                            },
                        ]
                }, 
                {
                    label: 'Mobile',
                    options: 
                        [
                            {
                                name:'Any mobile',
                                value:'mobile_any'
                            },
                            {
                                name:'iOS',
                                value:'mobile_ios'
                            },
                            {
                                name:'Android',
                                value:'mobile_android'
                            },
                            {
                                name:'Popka Test',
                                value:'mobile_popka'
                            },
                        ]
                },
            ],
        }
    },
    methods: {
         removeGroup(id) {
            var accounts = this.advanced.accounts;
            var groupIds = accounts[0].group_ids;//assumed that we can only delete something when there is at least one record
            
            groupIds = groupIds.filter(function(item){
                if (item != id) return item;
            });
            var accounts = [];
            if (groupIds.length) {
                accounts = [{ "type": "yandex", "group_ids": groupIds }];
            }

            this.$store.state.project.advanced.accounts = accounts;
        },
        getGroupName(id) {
            var filtered = this.accounts.filter(function(item){
                if (item.id == id) return item;
            });
            if(!filtered.length) return 'unknown group';
            return filtered[0].name;
        },
        addSelectedGroup() {
            if (!this.advanced.accounts) {
                this.advanced.accounts = {};
            }

            var accounts = this.advanced.accounts;//[0].groupIds;
            
            if (!accounts.length) {
                var groupIds = [];   
            } else {
                groupIds = accounts[0].group_ids;
            }
            var that = this;//context handler for closure
            var intersect = groupIds.filter(function(item){
                if (item == that.selectedGroupId) return item;
            });

            if (intersect.length) {
                return 0;//already in array
            }
            groupIds.push(this.selectedGroupId);
            this.$store.state.project.advanced.accounts = [ { "type": "yandex", "group_ids": groupIds }];
        },
        handleClose(done) {
        this.$confirm('Are you sure you want to close this?')
          .then(_ => {
            done();
          })
          .catch(_ => {});
        },
        getTitle() {
            return 'Advanced settings for bot "'+ this.bot.name + '" with id ' + this.bot.id;
        },
        resetToDefault() {
            this.drawer = false;
            this.$store.dispatch('project/deletePlaybookSettings', {
                project_id: this.bot.project_id, 
                bot_id: this.bot.id,
            });
        },
        handleClose(tag) {
            this.advanced.proxy_tags.splice(this.advanced.proxy_tags.indexOf(tag), 1);
        },
        handleCloseIncludeTags(tag) {
            this.advanced.include_tags.splice(this.advanced.include_tags.indexOf(tag), 1);
        },
        openDialog() {
            //this.dialogVisible = true;   
            this.drawer = true;   
            this.$store.dispatch('project/getPlaybookSettings', {
                project_id: this.bot.project_id, 
                bot_id: this.bot.id,
            });
        },
        addTag() {
            if (this.tagInput.length) {
                this.advanced.proxy_tags.push(this.tagInput);
                this.tagInput = '';
            }
        },
        addIncludeTag() {
            if (this.tagIncludeInput.length) {
                this.advanced.include_tags.push(this.tagIncludeInput);
                this.tagIncludeInput = '';
            }
        },
        saveBotSettings() {
            this.advanced.project_id = this.bot.project_id;
            this.advanced.bot_id = this.bot.id;
            if (this.advanced.country_codes[0] == "") {
                this.advanced.country_codes = [];
            }
            this.$store.dispatch('bot/setAdvanced', this.advanced);
        },
        getGroupName(id) {
            var filtered = this.accounts.filter(function(item){
                if (item.id == id) return item;
            });
            if(!filtered.length) return 'unknown group';
            return filtered[0].name;
        },
        getProxyTagName(id) {
            return id;
            /**var filtered = this.proxies_tags.filter(function(item){
                if (item.id == id) return item;
            });
            if(!filtered.length) return 'unknown proxy tag';
            return filtered[0].name;*/
        },
        removeGroup(id) {
            var accounts = this.advanced.accounts;
            var groupIds = accounts[0].group_ids;//assumed that we can only delete something when there is at least one record
            
            groupIds = groupIds.filter(function(item){
                if (item != id) return item;
            });
            var accounts = [];
            if (groupIds.length) {
                accounts = [{ "type": "yandex", "group_ids": groupIds }];
            }

            this.$store.state.project.playbookAdvanced.accounts = accounts;
        },
        removeProxyTag(id) {
            var tags = this.advanced.proxy_tags;
            
            tags = tags.filter(function(item){
                if (item != id) return item;
            });
            
            this.$store.state.project.playbookAdvanced.proxy_tags = tags;
        },
        addSelectedGroup() {
            if (!this.advanced.accounts) {
                this.advanced.accounts = {};
            }

            var accounts = this.advanced.accounts;//[0].groupIds;
            
            if (!accounts.length) {
                var groupIds = [];   
            } else {
                groupIds = accounts[0].group_ids;
            }
            var that = this;//context handler for closure
            var intersect = groupIds.filter(function(item){
                if (item == that.selectedGroupId) return item;
            });

            if (intersect.length) {
                return 0;//already in array
            }
            groupIds.push(this.selectedGroupId);
            this.$store.state.project.playbookAdvanced.accounts = [ { "type": "yandex", "group_ids": groupIds }];
        },
        addSelectedProxyTag() {
            var tags = this.advanced.proxy_tags;//[0].groupIds;
            
            var that = this;//context handler for closure
            var intersect = tags.filter(function(tag){
                if (tag == that.selectedProxyTag) return tag;
            });

            if (intersect.length) {
                return 0;//already in array
            }
            tags.push(this.selectedProxyTag);
            this.$store.state.project.playbookAdvanced.proxy_tags = tags;
        },
        handleCloseIncludeTags(tag) {
            this.advanced.include_tags.splice(this.advanced.include_tags.indexOf(tag), 1);
        },
        addIncludeTag() {
            if (this.tagIncludeInput.length) {
                this.advanced.include_tags.push(this.tagIncludeInput);
                this.tagIncludeInput = '';
            }
        },
        addTag() {
            if (this.tagInput.length) {
                this.advanced.proxy_tags.push(this.tagInput);
                this.tagInput = '';
            }
        },
        handleClose(tag) {
            this.advanced.proxy_tags.splice(this.advanced.proxy_tags.indexOf(tag), 1);

        },
        handleIncludeClose(tag) {
            this.includeTags.splice(this.includeTags.indexOf(tag), 1);
        },
        handleExcludeClose(tag) {
            this.excludeTags.splice(this.excludeTags.indexOf(tag), 1);
        },
        showIncludeInput() {
            this.inputIncludeVisible = true;
            this.$nextTick(_ => {
            this.$refs.saveTagInputInclude.$refs.input.focus();
            });
        },
        handleInputConfirmIncluded() {
            let inputValue = this.inputValueIncluded;
            if (inputValue) {
            this.includeTags.push(inputValue);
            }
            this.inputIncludeVisible = false;
            this.inputValueIncluded = '';
        },

        showExcludeInput() {
            this.inputExcludeVisible = true;
            this.$nextTick(_ => {
            this.$refs.saveTagInputExclude.$refs.input.focus();
            });
        },

        handleInputConfirmExcluded() {
            let inputValue = this.inputValueExcluded;
            if (inputValue) {
            this.excludeTags.push(inputValue);
            }
            this.inputExcludeVisible = false;
            this.inputValueExcluded = '';
        },
        getDefaultTableData() {
            return [
               
            ]
        },
        setChanged() {
            //compare with original
            this.hasChanged = true;
        },
        getLanguageCodes() {
            if (this.advanced.language_codes.length === 0) {
                return "";
            }

            return this.advanced.language_codes.join("\n");
        },
        getCountryCodes() {
            if (this.advanced.country_codes.length === 0) {
                return "";
            }

            return this.advanced.country_codes.join("\n");
        },
        handleClose(tag) {
            this.advanced.proxy_tags.splice(this.advanced.proxy_tags.indexOf(tag), 1);
        },
    },
    computed: {        
        ...mapState('project', {
            error: 'error',
            pbLoading: 'pb_loading',
            stats: 'stats',
            advanced: 'playbookAdvanced',
            accounts: 'accounts',
            proxies: 'proxies',
            proxies_tags: 'proxies_tags',
            languages: 'languages',
            pools: 'pools',
        }),
        ...mapGetters('project', [
        'isEmpty'
        ]),
    },
}
</script>

<style lang="scss" scoped>
    #addTagButton{
        margin-left:5px;
    }
    .el-tag + .el-tag {
        margin-left: 10px;
    }
    .button-new-tag {
        margin-left: 10px;
        height: 32px;
        line-height: 30px;
        padding-top: 0;
        padding-bottom: 0;
    }
    .cursored {
        cursor: pointer;
    }
    .input-new-tag {
        width: 90px;
        margin-left: 10px;
        vertical-align: bottom;
    }
    #deviation {
        width:100px !important;
    }
    .colSets{
        margin-top:5px;
    }  
    .colName {
        margin-top:5px;
    }
    .el-divider--horizontal {
        margin:8px !important;
    }
    .slider{
        padding:30px;
        overflow: scroll;
    }
    
</style>
